export enum EnvMapMappingTypesName {
  UVMapping = 'UVMapping',
  CubeReflectionMapping = 'CubeReflectionMapping',
  CubeRefractionMapping = 'CubeRefractionMapping',
  CubeUVReflectionMapping = 'CubeUVReflectionMapping',
  EquirectangularReflectionMapping = 'EquirectangularReflectionMapping',
  EquirectangularRefractionMapping = 'EquirectangularRefractionMapping'
}
